import { actionCreator } from 'utils';
import * as MachineTypes from '../types/machineTypes';

// L O A D   M A C H I N E S
export function loadMachines() {
    return {
        type: MachineTypes.LOAD_MACHINES,
    };
}

export function loadMachinesRes(data) {
    return {
        type: actionCreator(MachineTypes.LOAD_MACHINES, 'res'),
        data,
    };
}

export function loadMachinesErr() {
    return {
        type: actionCreator(MachineTypes.LOAD_MACHINES, 'err'),
    };
}
// L O A D   M A C H I N E S

// A D D   N E W   M A C H I N E
export function addNewMachine(data) {
    return {
        type: MachineTypes.ADD_NEW_MACHINE,
        data,
    };
}

export function addNewMachineRes(loading, success) {
    return {
        type: actionCreator(MachineTypes.ADD_NEW_MACHINE, 'res'),
        loading,
        success,
    };
}

export function addNewMachineErr(error) {
    return {
        type: actionCreator(MachineTypes.ADD_NEW_MACHINE, 'err'),
        error,
    };
}
// A D D   N E W   M A C H I N E

// E D I T   M A C H I N E
export function editMachine(data) {
    return {
        type: MachineTypes.EDIT_MACHINE,
        data,
    };
}

export function editMachineRes(loading, success) {
    return {
        type: actionCreator(MachineTypes.EDIT_MACHINE, 'res'),
        loading,
        success,
    };
}

export function editMachineErr() {
    return {
        type: actionCreator(MachineTypes.EDIT_MACHINE, 'err'),
    };
}
// E D I T   M A C H I N E

// L O A D   E D I T A B L E   M A C H I N E
export function loadEditableMachine(id) {
    return {
        type: MachineTypes.LOAD_EDITABLE_MACHINE,
        id,
    };
}

export function loadEditableMachineRes(data) {
    return {
        type: actionCreator(MachineTypes.LOAD_EDITABLE_MACHINE, 'res'),
        data,
    };
}

export function loadEditableMachineErr() {
    return {
        type: actionCreator(MachineTypes.LOAD_EDITABLE_MACHINE, 'err'),
    };
}

export function setEmptyEditableMachine() {
    return {
        type: MachineTypes.SET_EMPTY_EDITABLE_MACHINE,
    };
}
// L O A D   E D I T A B L E   M A C H I N E


// D E L E T E    M A C H I N E
export function deleteMachine(data) {
    return {
        type: MachineTypes.DELETE_MACHINE,
        data,
    };
}

export function deleteMachineRes(loading, success) {
    return {
        type: actionCreator(MachineTypes.DELETE_MACHINE, 'res'),
        loading,
        success,
    };
}

export function deleteMachineErr() {
    return {
        type: actionCreator(MachineTypes.DELETE_MACHINE, 'err'),
    };
}
// D E L E T E    M A C H I N E
